import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { mockData } from '../../mock';
import ResponsiveImage from '../ResponsiveImage';

const BlogPreviewSection = () => {
  const navigate = useNavigate();
  const posts = mockData.blogPosts.slice(0, 3);

  return (
    <section
      className="section-padding"
      data-testid="blog-preview-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Latest Insights</h2>
          <p className="section-subtitle">
            Evidence-based perspectives on strength, mobility, recovery and longevity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map((post) => (
            <Card
              key={`blog-${post.id}`}
              className="blog-preview-card cursor-pointer"
              onClick={() => navigate(`/blog/${post.slug}`)}
              data-testid={`blog-preview-card-${post.id}`}
            >
              <div className="blog-preview-image">
                <ResponsiveImage
                  src={post.image}
                  alt={post.title}
                  sizes="(max-width: 768px) 100vw, 33vw"
                />
                <div className="blog-category-badge">{post.category}</div>
              </div>
              <CardHeader>
                <CardTitle className="blog-preview-title">{post.title}</CardTitle>
                <div className="blog-meta">
                  <span className="blog-meta-item">
                    <Clock size={14} aria-hidden="true" />
                    {post.readTime}
                  </span>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="blog-preview-excerpt">
                  {post.excerpt}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button
            className="btn-primary"
            onClick={() => navigate('/blog')}
            data-testid="blog-view-all-btn"
          >
            View All Articles
            <ArrowRight className="ml-2" size={18} />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BlogPreviewSection;
